module.exports = __webpack_public_path__ + "static/img/submit-page-icon.d0641355.png";